import React, { useState } from "react";
import { TypeAnimation } from "react-type-animation";
import Zmage from "react-zmage";

export default function About(props) {
  const [language] = useState("en");
  if (!props.data) return null;

  const translations = {
    en: {
      greeting: "Hi, I am Malik",
      job: "Software Engineer",
      human: "Human Being",
      description: props.data.description,
    },
    id: {
      greeting: "Halo, saya Malik",
      job: "Insinyur Perangkat Lunak",
      human: "Manusia",
      description: "Saya seorang pengembang yang antusias dengan teknologi.",
    },
  };

  const profilepic = "images/" + props.data.image;



  return (
    <header id="home">
      <nav id="nav-wrap">
        <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
          Show navigation
        </a>
        <a className="mobile-btn" href="#home" title="Hide navigation">
          Hide navigation
        </a>

        <ul id="nav" className="nav">
          <li className="current">
            <a className="smoothscroll font-geist-semibold" href="#home">
              Home
            </a>
          </li>
          <li>
            <a className="smoothscroll font-geist-semibold" href="#about">
              About
            </a>
          </li>
          <li>
            <a className="smoothscroll font-geist-semibold" href="#resume">
              Resume
            </a>
          </li>
          <li>
            <a className="smoothscroll font-geist-semibold" href="#portfolio">
              Works
            </a>
          </li>
          <li>
            <a className="smoothscroll font-geist-semibold" href="#social">
              Socials
            </a>
          </li>
          {/* <li>
            <div className="relative inline-block text-left">
              <Menu as="div" className="relative">
                <Menu.Button className="flex items-center gap-2 px-4 py-2 text-white ">
                  <img src="/images/id-flag.svg" className="w-8" />
                </Menu.Button>

                <Menu.Items className="absolute right-0 mt-2 w-44 text-black bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black/5 focus:outline-none">
                  <div className="p-1 flex flex-col w-44">
                    <MenuItem>
                      <div className="flex flex-row gap-3 items-center justify-center">
                        <img src="/images/id-flag.svg" className="w-5" />
                        <p className="text-black font-geist-semibold">ID</p>
                      </div>
                    </MenuItem>
                    <MenuItem>
                      <div className="flex flex-row gap-3 items-center justify-center">
                        <img src="/images/en-flag.svg" className="w-5" />
                        <p className="text-black font-geist-semibold">EN</p>
                      </div>
                    </MenuItem>
                  </div>
                </Menu.Items>
              </Menu>
            </div>
          </li> */}
        </ul>
      </nav>

      <div className="row banner">
        <div className="banner-text">
          <Zmage
            alt="My Pic"
            className="profile-pic shadow-md"
            src={profilepic}
          />
          <TypeAnimation
            sequence={[
              translations[language].greeting,
              2000,
              translations[language].job,
              2000,
              translations[language].human,
              4000,
            ]}
            wrapper="span"
            cursor={true}
            repeat={Infinity}
            className="responsive-headline text-5xl font-bold font-geist  text-white"
          />
          <h3 className="!mt-8 text-3xl leading-[3.5rem] font-geist">
            {translations[language].description}
          </h3>
        </div>
      </div>

      <p className="scrolldown">
        <a className="smoothscroll" href="#about">
          <i className="icon-down-circle"></i>
        </a>
      </p>
    </header>
  );
}
